<!-- src/components/CarFilter.vue -->
<template>
    <div class="car-filter">
        <div class="filter-section">
            <h3 class="section-title">{{ $t('brand') }}</h3>
            <select id="make" v-model="localFilters.make" @change="applyFilters" class="filter-select">
                <option value="">{{ $t('all_brands') }}</option>
                <option v-for="brand in uniqueBrands" :key="brand" :value="brand">{{ brand }}</option>
            </select>
        </div>

        <div class="filter-section">
            <h3 class="section-title">{{ $t('price_range') }}</h3>
            <div class="range-inputs">
                <input 
                    id="minPrice" 
                    type="number" 
                    v-model.number="localFilters.minPrice" 
                    :placeholder="$t('min_price')" 
                    @input="applyFilters" 
                    class="filter-input" 
                />
                <span class="range-separator">{{ $t('to') }}</span>
                <input 
                    id="maxPrice" 
                    type="number" 
                    v-model.number="localFilters.maxPrice" 
                    :placeholder="$t('max_price')" 
                    @input="applyFilters" 
                    class="filter-input" 
                />
            </div>
        </div>

        <div class="filter-section">
            <h3 class="section-title">{{ $t('fuel_type') }}</h3>
            <select id="fuelType" v-model="localFilters.fuelType" @change="applyFilters" class="filter-select">
                <option value="">{{ $t('any_fuel_type') }}</option>
                <option value="Gasoline">{{ $t('fuel_types.gasoline') }}</option>
                <option value="Diesel">{{ $t('fuel_types.diesel') }}</option>
                <option value="Electric">{{ $t('fuel_types.electric') }}</option>
                <option value="Electric/Gasoline">{{ $t('fuel_types.electric') }}/{{ $t('fuel_types.gasoline') }}</option>
                <option value="Electric/Diesel">{{ $t('fuel_types.electric') }}/{{ $t('fuel_types.diesel') }}</option>
            </select>
        </div>
    </div>
</template>

<script setup>
import { ref, watch, computed } from 'vue'
import { useCarsStore } from '@/stores/cars'

const carsStore = useCarsStore()
const localFilters = ref({ ...carsStore.filters })

const uniqueBrands = computed(() => {
    const brands = new Set()
    carsStore.cars.forEach(car => brands.add(car.make))
    return Array.from(brands).sort()
})

const applyFilters = () => {
    carsStore.updateFilters(localFilters.value)
}

watch(
    () => carsStore.filters,
    (newFilters) => {
        localFilters.value = { ...newFilters }
    },
    { deep: true }
)
</script>

<style scoped>
.car-filter {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    padding: 1.5rem;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.filter-section {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.section-title {
    margin: 0;
    font-size: 1rem;
    font-weight: 600;
    color: #333;
}

.filter-select, .filter-input {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 0.9rem;
}

.filter-select:focus, .filter-input:focus {
    outline: none;
    border-color: #45ABFF;
    box-shadow: 0 0 0 2px rgba(69, 171, 255, 0.2);
}

.range-inputs {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.range-separator {
    color: #666;
    font-size: 0.9rem;
}

.reset-button {
    margin-top: 1rem;
    padding: 0.75rem;
    background-color: #45ABFF;
    color: white;
    border: none;
    border-radius: 4px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s;
}

.reset-button:hover {
    background-color: #3a96e0;
}
</style>